// @mui
import type { BoxProps } from '@mui/material';

// icons
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';
import { forwardRef } from 'react';

//
import type { IconifyProps } from './types';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  icon: IconifyProps;
}

const Iconify = forwardRef<SVGElement, Props>(
  ({ icon, sx, width = 20, ...other }, ref) => (
    <Box
      component={Icon}
      icon={icon}
      ref={ref}
      sx={{ height: width, width, ...sx }}
      {...other}
    />
  )
);

Iconify.displayName = 'Iconify';

export default Iconify;
